export const br_pt = {
  '404': {
    TITLE: 'Ops...',
    PAGENOTFOUND: 'Esta página não existe',
    BUTTON: 'Voltar ao Início',
    RECIPES: 'Descubra as nossas receitas'
  },
  HOME: {
    SHOWCASE: 'Receitas',
    CATCH_PHRASE: '',
    SHOWCASE_SEE_ALL: 'Ver todas as receitas',
    MAGAZINE: { TITLE: 'DESTAQUES', BUTTON: 'Confira o nosso blog' },
    OUR_VEGETABLES: 'Os nossos vegetais',
    SOCIAL_WALL: 'Juntos, compartilhamos a paixão pelos vegetais',
    FAQ_TITLE: 'Perguntas frequentes',
    FAQ_SEE_MORE: 'Veja mais',
    FLOWBOX: ''
  },
  SELECT: { DEFAULT_VALUE: 'Ver todos' },
  MENU: {
    CONTACT_US: 'Fale conosco',
    MY_ACCOUNT: 'Minha conta',
    GOOD_DEALS: 'Promoções',
    NEWSLETTER: 'Newsletter Bonduelle',
    SUBMENU_TOGGLE: 'Submenu {{label}}'
  },
  FOOTER: {
    LINK: {
      BONDUELLE: 'Bonduelle.com.br',
      CREDITS: 'Créditos',
      LEGAL_NOTICE: 'TERMOS LEGAIS',
      TERMS_OF_SALES: 'Condições de venda',
      COOKIES: 'POLÍTICA DE COOKIES',
      SITEMAP: 'Mapa do site',
      PRIVACY_POLICY: 'Política de privacidade',
      ALL_RIGHTS_RESERVED: '2020© Todos os direitos reservados'
    },
    HISTORY: {
      TITLE: 'Bonduelle, desde 1853',
      TEXT: 'Há 7 gerações, a Bonduelle promove uma agricultura que respeita a terra e as pessoas. Do campo ao prato, trabalhamos todos os dias por uma alimentação mais vegetal e um futuro melhor.'
    },
    NEWSLETTER: {
      TITLE: 'Comunidade Bonduelle',
      TEXT: 'Aceito receber a newsletter «Tudo sobre os vegetais Bonduelle» (novidades, promoções, concursos, artigos…)',
      PLACEHOLDER: 'Seu e-mail',
      GDPR_LINK: 'Mais informação sobre o uso dos seus dados'
    }
  },
  PRODUCTS: 'Produtos',
  MAGAZINE: {
    HOME: 'Bem-vindo ao nosso blog',
    CATCH_PHRASE: '',
    MENU: { BONDUELLE_LINK: 'Ir para Bonduelle.pt' },
    SHOWCASE: 'Para ver',
    PREVIOUS_ARTICLES: 'Artigos anteriores',
    PREVIOUS_ARTICLES_SEE_ALL: 'Ver todos os artigos',
    PREVIOUS_EDITIONS: 'Edições anteriores',
    PREVIOUS_EDITIONS_SEE_ALL: 'Ver mais edições',
    PREVIOUS_ARTICLES_BY_CATEGORY: 'Artigos anteriores por categoria',
    RUBRIC: {
      SEE_ALL: 'Ver todas as receitas',
      SEE_ALL_ARTICLES: 'Ver todos os artigos',
      ON: 'Artigos sobre'
    },
    RUBRIC_COOK: { ON: 'Receitas de' },
    ARTICLE: { JOIN_US: 'Se junte a nós', READ_ALSO: 'Ler também' },
    RECIPE: {
      INGREDIENTS: 'Ingredientes',
      INGREDIENTS_LABEL_DESC: 'para {{value}} pessoas',
      INGREDIENTS_LABEL_ONE_DESC: 'para {{value}} pessoa',
      INGREDIENTS_LABEL: 'Ingredientes para {{value}} pessoas',
      INGREDIENTS_LABEL_ONE: 'Ingredientes para {{value}} pessoa',
      PEOPLES: '{{value}} pessoas',
      PEOPLE: '{{value}} pessoa',
      DIFFICULTY: { EASY: 'Fácil', MEDIUM: 'Médio', HARD: 'Difícil' },
      COST: { CHEAP: 'Barato', EXPENSIVE: 'Caro' },
      TIMING: { MIN: 'min', HOURS: 'Horas' },
      STEP: 'Etapa',
      DISCOVER_ALSO: 'Descubra também'
    }
  },
  ARTICLE: { DISCOVER_ALSO: 'Descubra também', INGREDIENTS: 'Ingredientes' },
  SF: {
    SLIDE: { DISCOVER: 'Descubra' },
    SEARCH: { PLACEHOLDER: 'Pesquisar', ALL: 'Tudo sobre' },
    NEWSLETTER: {
      BTN_LABEL: 'Estou me cadastrando',
      PLACEHOLDER: 'Seu e-mail',
      ERROR_MESSAGE: 'E-mail inválido',
      ALREADY_SUBSCRIBED: 'Você já está registrado',
      GDPR: {
        TXT: 'Mais informações sobre o uso dos seus dados',
        LINK: '/politica-de-privacidade#gdpr'
      }
    },
    MONTHLY_FOLDER: { TITLE: 'Novidades do mês' },
    MINI_NEWSLETTER: {
      PLACEHOLDER: 'Seu e-mail',
      GDPR: {
        TXT: 'Mais informações sobre o uso dos seus dados',
        LINK: '/politica-de-privacidade#gdpr'
      }
    },
    SOCIALITEM: {
      SHARE: 'Compartilhe',
      COMMENT: 'Comente',
      BONDUELLE: 'Bonduelle'
    },
    SEARCHRECIPE: { DISCOVER_ALL: 'Pesquise todas as receitas!' },
    FORM: {
      ERROR: 'Campo inválido',
      PHOTO: {
        ADD: 'Arraste suas fotos aqui',
        DELETE: 'Deletar foto',
        SEE: 'Ver',
        ADD_SUB: 'ou clique para selecionar arquivos'
      }
    }
  },
  CORPORATE: {
    COMPANY_STORY: 'Nossa história',
    CSR_COMMITMENT: 'Compromisso RSC',
    VEGETABLE_INNOVATIONS: 'O Grupo Bonduelle',
    NEWS: 'Todas as novidades',
    SEE_MORE: 'Ver mais artigos',
    ON: 'Artigos sobre',
    NUMBERS: 'Os nossos compromissos, em números'
  },
  NEWSLETTER: {
    TITLE: 'Se inscreva em nossa newsletter',
    SUBTITLE: 'Promoções, inspirações culinárias e um pouco de cultura!'
  },
  ROUTES: {
    products: 'produtos',
    news: 'novidades',
    'since-1853': 'sobre-nos',
    'field-plate': 'do-campo-a-mesa',
    'company-story': 'a-nossa-historia',
    'csr-commitments': 'compromisso-rsc',
    'vegetal-innovations': 'inovacao-vegetal',
    magazine: 'blog',
    all: 'ver-tudo',
    article: 'artigo',
    cook: 'alimentaçao',
    cultivate: 'tendencias',
    explore: 'explore',
    recipe: 'esperar-receita',
    recipes: 'receitas',
    'recipes-home': 'receitas-inicio',
    r: 'r',
    credits: 'creditos-pt',
    'legal-notice': 'mencoes-legais',
    'terms-of-sales': 'condicoes-de-venda',
    cookies: 'politica-de-cookies',
    sitemap: 'mapa do site',
    'privacy-policy': 'politica-de-privacidade',
    'all-rights-reserved': 'todos-os-direitos-reservados',
    search: 'pesquisar',
    'articles-search': 'artigo',
    vegetables: 'produtos',
    p: 'p',
    contact: 'contato',
    'info-product': 'informacao-sobre-produto',
    'note-product': 'notas-sobre-produto',
    suggestion: 'sugestoes',
    'other-request': 'nova-pesquisa',
    faq: 'perguntas-frequentes',
    'all-themes': 'todos-os-temas',
    'products-search': 'pesquisar-produtos',
    recipesearch: 'pesquisar-receitas',
    'product-news': 'novos-produtos',
    'good-deals': 'promoções',
    'not-found': 'erro',
    'menu-page': 'menu-page',
    'menu-one': 'menu-one',
    'menu-two': 'menu-two',
    'menu-three': 'menu-three',
    'menu-four': 'menu-four',
    'menu-external': 'menu-external',
    'theme-pasta-rice': '',
    'theme-bowls': '',
    'theme-soup': '',
    'theme-snack': '',
    'theme-sauce': '',
    'theme-unique-plate': '',
    'theme-over': '',
    'theme-legumin': 'legumin',
    'theme-ingredients-recipes': '',
    'theme-cook-plate': ''
  },
  BREAD: {
    products: 'produtos',
    news: 'novidades',
    'since-1853': 'sobre-nos',
    'field-plate': 'do-campo-a-mesa',
    'company-story': 'a-nossa-historia',
    'csr-commitments': 'compromisso-rsc',
    'vegetal-innovations': 'inovacao-vegetal',
    magazine: 'blog',
    all: 'ver-tudo',
    article: 'artigo',
    cook: 'alimentaçao',
    cultivate: 'tendencias',
    explore: 'explore',
    recipe: 'esperar-receita',
    recipes: 'receitas',
    'recipes-home': 'receitas inicio',
    'articles-search': 'artigo',
    search: 'pesquisar',
    vegetables: 'produtos',
    contact: 'contato',
    'info-product': 'informacao-sobre-produto',
    'note-product': 'notas-sobre-produto',
    suggestion: 'sugestoes',
    'other-request': 'nova-pesquisa',
    faq: 'perguntas frequentes',
    'all-themes': 'todos-os-temas',
    'products-search': 'pesquisar-produtos',
    recipesearch: 'pesquisar-receitas',
    'product-news': 'novos-produtos',
    'good-deals': 'promoções',
    'not-found': 'erro',
    'menu-page': 'menu-page',
    'menu-one': 'menu-one',
    'menu-two': 'menu-two',
    'menu-three': 'menu-three',
    'menu-four': 'menu-four'
  },
  'depuis-1853': 'artigo',
  MENU_PAGE: { TITLE1: '', TITLE2: '', TITLE3: '', TITLE4: '', EXTERNAL: '' },
  TECHNICAL: { MENU_PAGE: '' },
  SEO: {
    TITLE: {
      MENU_ONE: '',
      MENU_TWO: '',
      MENU_THREE: '',
      MENU_FOUR: '',
      HOME: 'Bonduelle',
      SEARCH: {
        MAIN: '{{value}} | Bonduelle',
        RECIPES: '{{value}} ordenado por receita | Bonduelle',
        VEGETABLES: '{{value}} ordenado por produto | Bonduelle',
        ARTICLES: '{{value}} ordenado por artigo | Bonduelle'
      },
      CONTACT: 'Contato do Serviço de Atendimento ao Consumidor | Bonduelle',
      RECIPES: 'Receita culinária: sopa, quiche, lasanha de legumes...  | Bonduelle',
      RECIPE_HOME: 'Receita para cozinhar com vegetais no Natal, casamentos, festas | Bonduelle',
      RECIPE: 'Receita {{value}} | Bonduelle',
      PRODUCTS: 'Vegetais cozidos, conservas, congelados para cozinhar | Bonduelle',
      NEWS: 'Dicas, culinária, como preparar os vegetais | Bonduelle',
      CORPORATE: {
        NEWS: 'Últimos artigos, notícias sobre vegetais e culinária | Bonduelle',
        COMPANY_STORY: 'Apresentação da empresa | Bonduelle',
        CSR_COMMITMENTS: 'Valores/princípios éticos e compromisso do Grupo | Bonduelle',
        VEGETAL_INNOVATIONS: 'Inovação vegetal: novas explorações, produtos | Bonduelle',
        FIELD_PLATE: 'Nossos vegetais saem da terra | Bonduelle',
        ARTICLE: '{{value}} | Bonduelle',
        VEGETABLE: '{{value}}, descubra mais sobre este vegetal | Bonduelle'
      },
      PRODUCT: '{{value}}  Vegetais cozidos Bonduelle',
      MAGAZINE: {
        NEWS: 'Notícias sobre vegetais, receitas para adultos e crianças | Bonduelle',
        ARTICLE: '{{value}} Bonduelle',
        COOK: 'Receitas com vegetais: fáceis e rápidas | Bonduelle',
        GROW: 'Cultivar e manter os vegetais na sua horta | Bonduelle',
        EXPLORE: 'Descubra novos vegetais e sabores para as crianças | Bonduelle',
        RECIPE: 'Receita {{value}} | Bonduelle'
      },
      FAQ: 'Q&As: Perguntas frequentes | Bonduelle',
      NOTFOUND: 'Erro 404, por favor, tente novamente mais tarde | Bonduelle',
      RECIPES_ALL: 'Todas as nossas receitas de vegetais ',
      RECIPETYPE: 'Receitas culinárias: {{value}} de vegetais',
      RECIPESEASON: 'Receita de vegetais da época: {{value}}.',
      RECIPEPREPARATION: 'Receitas culinárias: tempo de preparo {{value}}.',
      RECIPEDIFFICULTY: 'Receitas fáceis de vegetais: {{value}} de vegetais',
      RECIPEVEGETABLE: 'Receita culinária fácil à base de {{value}}',
      RECIPECOST: 'Receita de vegetais {{value}}.',
      RECIPEDISH: 'Receitas culinárias e vegetais para {{value}}',
      RECIPEDESC: 'Receita culinária {{value}}.',
      '2RECIPEFACETS': 'Receita culinária {{value}}.',
      '4RECIPEFACETS': 'Receitas culinárias {{value}}',
      PRODUCTSEASON: 'Receitas de vegetais fáceis de fazer: {{value}}',
      PRODUCTTECHNO: 'Receita fácil de vegetais {{value}}',
      PRODUCTVEGETABLE: 'Receita fácil de vegetais à base de {{value}}',
      PRODUCTRANGE: 'Receita fácil de vegetais à base de {{value}}',
      THEME_ALL: 'Vegetais em conserva, congelados para cozinhar.',
      THEME_STARTER: 'Ideia para cozinhar receitas de entradas com vegetais',
      THEME_SALAD: 'Ideias para cozinhar uma salada mista no verão',
      THEME_CAN: '',
      THEME_FROZEN: '',
      THEME_READY_MEALS: '',
      THEME_BIO: '',
      THEME_VEGETABLES: '',
      THEME_RECIPE: 'Ideias para cozinhar receitas fáceis e rápidas com vegetais',
      THEME_PLATE: 'Ideias para cozinhar pratos frios e quentes com vegetais',
      THEME_ACC: 'Ideias de legumes para acompanhar carne e peixe.',
      THEME_SNACK: 'Ideias de vegetais para receitas rápidas',
      RECIPE_THEME1: '',
      '2PRODUCTSFACETS': 'Receitas de vegetais {{value}}'
    },
    DESCRIPTION: {
      MENU_ONE: '',
      MENU_TWO: '',
      MENU_THREE: '',
      MENU_FOUR: '',
      HOME: 'Vegetais em conserva e congelados. Descubra nossos deliciosos vegetais, ideias de receitas para inspirar seus pratos. Bonduelle: uma fonte de desejo de vegetais e receitas.',
      SEARCH: {
        MAIN: 'Descubra nossas ideias de receitas e vegetais para {{value}}. Receitas simples e saborosas.',
        RECIPES: 'Todos os nossos {{value}} ordenados por receita. Receitas simples e saborosas. ',
        VEGETABLES: 'Todos os nossos {{value}} ordenados por vegetal. Receitas simples e saborosas. ',
        ARTICLES: 'Todos os nossos {{value}} ordenados por artigo. Receitas simples e saborosas. '
      },
      CONTACT: 'Tem alguma pergunta para nos fazer? Precisa de informações sobre algum produto, serviço ou ação em andamento? Você pode entrar em contato através do nosso Serviço de Atendimento ao Consumidor. Resposta garantida em 48 horas.',
      RECIPES: 'Descubra saborosas receitas culinárias à base de vegetais. Deixe todos felizes, preparando receitas fáceis. Receitas simples e saborosas.',
      RECIPE_HOME: 'Descubra saborosas receitas à base de vegetais para as festas. Mime seus entes queridos com algo especial, nesta ocasião especial. Receitas simples e saborosas.',
      RECIPE: '',
      PRODUCTS: 'Nossa ampla linha de produtos dá a você a possibilidade de preparar receitas saborosas, fáceis e equilibradas. Receitas simples e saborosas.',
      NEWS: 'Descubra como preparar seus legumes, cozinhá-los de forma eficiente e criar pratos saborosos. Receitas simples e saborosas.',
      CORPORATE: {
        NEWS: 'Últimas notícias sobre o mundo agrícola, a inovação vegetal, os resíduos e como comer melhor de uma forma simples. Receitas simples e saborosas. ',
        COMPANY_STORY: 'Quer saber mais sobre o mundo dos vegetais, do mundo agrícola e das hortaliças? Descubra tudo isto no nosso blog. Receitas simples e saborosas. ',
        CSR_COMMITMENTS: 'Quer saber como são cultivados os nossos vegetais, de onde vêm, como respeitamos o meio ambiente? Encontre as respostas às perguntas sobre os nossos vegetais, aqui.',
        VEGETAL_INNOVATIONS: 'A inovação vegetal está no centro das nossas preocupações. Novas formas de cultivar e mais ecológicas, com menos resíduos... Receitas simples e saborosas. ',
        VEGETABLE: '',
        FIELD_PLATE: 'Descubra nossas deliciosas receitas. Serão um prazer para todos os paladares. Receitas simples e saborosas.',
        ARTICLE: ''
      },
      PRODUCT: '{{value}} para preparar saborosas receitas culinárias e satisfazer seus entes queridos. Receitas simples e saborosas.',
      MAGAZINE: {
        NEWS: 'Todas as novidades, notícias sobre vegetais, receitas equilibradas. Receitas simples e saborosas.',
        ARTICLE: '',
        COOK: 'Nossas deliciosas receitas serão um prazer para todos os paladares, descubra-as na nossa página. Receitas simples e saborosas.',
        GROW: 'Quer cultivar seus próprios vegetais na sua horta? Descubra nossos conselhos e truques para cultivar e manter seus vegetais.',
        EXPLORE: 'Deixe que seus filhos descubram novas variedades de vegetais, através de receitas simples e eficazes. Receitas fáceis e saborosas.',
        RECIPE: ''
      },
      FAQ: 'Tem alguma pergunta? Agrupamos todas as perguntas mais frequentes para responder melhor às suas sugestões.',
      PAGE: 'página',
      RECIPETYPE: 'Descubra nossas receitas {{value}} e como cozinhar corretamente os vegetais. Receita vegetariana, rápida, original, fácil.',
      RECIPESEASON: 'Descubra as nossas receitas culinárias e como cozinhar bem os vegetais por {{value}}. Receita vegetariana, rápida, original, fácil.',
      RECIPEPREPARATION: 'Descubra as nossas receitas culinárias e como cozinhar bem os vegetais por {{value}}. Receita vegetariana, rápida, original, fácil.',
      RECIPEDIFFICULTY: 'Descubra as nossas receitas culinárias e como cozinhar vegetais {{value}}. Receita vegetariana, rápida, original, fácil.',
      RECIPEVEGETABLE: 'Descubra nossas receitas para cozinhar {{value}} e como cozinhar corretamente os vegetais. Receita vegetariana, rápida, original, fácil.',
      RECIPECOST: 'Descubra nossas receitas culinárias e como cozinhar seus vegetais corretamente para {{value}}. Receita vegetariana, rápida, original, fácil.',
      RECIPEDISH: 'Descubra as nossas receitas e como cozinhar bem os vegetais para {{value}} os convidados. Receita vegetariana, rápida, original, fácil.',
      RECIPEDESC: 'Descubra as nossas receitas culinárias e como cozinhar vegetais {{value}}. Receita vegetariana, rápida, original, fácil.',
      '2RECIPEFACETS': 'Descubra as nossas receitas culinárias e como cozinhar vegetais {{value}}. Receita vegetariana, rápida, original, fácil.',
      '4RECIPEFACETS': 'Descubra as nossas receitas culinárias e como cozinhar bem os vegetais {{value}}.',
      PRODUCTSEASON: 'Nossa ampla linha de produtos permite que você prepare receitas da época {{value}} saborosas, fáceis e equilibradas. Receitas simples e saborosas.',
      PRODUCTTECHNO: 'Nossa ampla linha de produtos permite que você prepare receitas da época {{value}} saborosas, fáceis e equilibradas. Receitas simples e saborosas.',
      PRODUCTVEGETABLE: 'Nossa ampla linha de produtos permite que você prepare receitas saborosas, fáceis e equilibradas, baseadas em {{value}}. Receitas simples e saborosas. Legumes cozidos.',
      PRODUCTRANGE: 'Nossa ampla linha de produtos permite que você prepare receitas saborosas, fáceis e equilibradas, baseadas em {{value}}. Receitas simples e saborosas. Legumes cozidos.',
      THEME_ALL: 'Nossa ampla linha de produtos permite que você prepare receitas saborosas, fáceis e equilibradas. Receitas simples e saborosas.',
      THEME_STARTER: 'Quer preparar uma refeição equilibrada? Uma ampla linha de produtos para preparar, de forma rápida e simples, receitas de entradas à base de vegetais, dicas e truques para melhorar suas refeições.',
      THEME_SALAD: 'Quer preparar uma refeição equilibrada? Uma ampla linha de produtos para preparar saladas rápidas e fáceis, dicas e truques para melhorar suas refeições.',
      THEME_CAN: '',
      THEME_FROZEN: '',
      THEME_READY_MEALS: '',
      THEME_BIO: '',
      THEME_VEGETABLES: '',
      THEME_RECIPE: 'Produtos para cozinhar de forma fácil e rápida deliciosas e equilibradas receitas à base de vegetais, conselhos e truques para melhorar as suas refeições. Receitas rápidas e equilibradas.',
      THEME_PLATE: 'Quer preparar uma refeição equilibrada? Produtos para cozinhar pratos quentes ou frios, à base de vegetais, fáceis e rápidos, dicas e truques para melhorar as suas refeições.',
      THEME_ACC: 'Produtos para cozinhar acompanhamentos rápidos e fáceis à base de vegetais, dicas e truques para melhorar suas refeições. Receitas simples e equilibradas.',
      THEME_SNACK: 'Quer preparar uma refeição equilibrada? Produtos para preparar receitas de aperitivos à base de vegetais, de forma fácil e rápida, dicas e truques para melhorar suas refeições.',
      RECIPE_THEME1: '',
      '2PRODUCTSFACETS': 'Nossa ampla linha de produtos permite que você prepare receitas saborosas, fáceis e equilibradas {{value}}. Receitas simples e saborosas.',
      NOTFOUND: 'Não foi encontrada a página solicitada. Sugerimos que faça uma nova pesquisa, ou tente novamente mais tarde.'
    },
    PIPE: { SOCIETY: ' | Bonduelle' },
    THEME_ALL: 'Todos',
    THEME_STARTER: 'Entradas',
    THEME_SALAD: 'Tudo para as minhas saladas',
    THEME_CAN: '',
    THEME_FROZEN: '',
    THEME_READY_MEALS: '',
    THEME_BIO: '',
    THEME_VEGETABLES: '',
    THEME_RECIPE: 'Ingredientes-receitas',
    THEME_PLATE: 'Prato principal',
    THEME_ACC: 'Acompanhamento',
    THEME_SNACK: 'Snacks'
  },
  VEGETABLE: {
    DISCOVER_VEGETABLE: 'Descubra nossas informações sobre vegetais',
    OURS_RECIPES: 'As nossas receitas',
    DISCOVER_ALSO: 'Descubra também...',
    SEE_ALL: 'Ver todos os vegetais',
    ON: 'Vegetais em'
  },
  RECIPE: {
    'INGREDIENTS_LABEL ': 'Ingredientes para {{value}} pessoas',
    PEOPLES: '{{value}} pessoas',
    DIFFICULTY: { EASY: 'Fácil', MEDIUM: 'Médio', HARD: 'Difícil' },
    COST: { CHEAP: 'Barato', EXPENSIVE: 'Caro' },
    TIMING: { MIN: 'min', HOURS: 'horas' },
    STEP: 'Etapa',
    DISCOVER_ALSO: 'Descubra também...',
    HOME_SEE_MORE: 'Descubra mais receitas',
    SHOWCASE: 'Destaques',
    HOME_BOOK: 'As nossas receitas',
    MIN_MORE: 'm e +',
    HOUR_MORE: 'h e +',
    FILTER_BY_CRITERIA: 'Filtrar por critérios',
    SORT_BY: 'Ordenar por',
    BEST_RATED: 'Os mais avaliados',
    MOST_CONSULTED: 'Os mais consultados',
    MEMBERS_RECIPES: 'Receitas de membros',
    CRITERIA: 'Novidades',
    DISCOVER: { RECIPES: 'Descubra as nossas receitas' },
    DISCOVER_RECIPE: 'Descubra a receita',
    INSTRUCTIONS: 'Instruções',
    DEFAULT_TAG: 'Ideia de receita',
    MOST_RECENT: 'Mais recentes',
    RECIPE_VIDEOS: 'Vídeos de receitas',
    PRODUCT_ASSOCIATE: 'Receita feita com',
    BUDGET_LOW: 'Barato',
    BUDGET_HIGH: 'Alto',
    BUDGET_MIDDLE: 'Médio',
    PRINT_RECIPE: 'Imprimir receita',
    LET_YOURSELF_SURPRISED: 'Deixe-se surpreender',
    COOK_TIP_TITLE: '',
    ENJOY_MEAL: '',
    FILTER: { LEGEND: 'Legenda' },
    SURPRISE: 'Deixe-se surpreender pelas nossas receitas',
    DISCOVER_RECIPE_IDEAS: 'Descubra todas as nossas ideias de receitas',
    FAST: 'Rápido',
    PEOPLE: '{{value}} pessoas',
    VEGGIE: 'Veggie',
    VEGAN: 'Vegano'
  },
  PREDIGGO: { DIFFICULTY: { EASY: 'Fácil', MEDIUM: 'Médio', HARD: 'Difícil' } },
  COOKIES: {
    TEXT: 'Ao continuar sua visita neste site, você está aceitando o uso de cookies por razões técnicas, com a finalidade de análise estatística e de gestão do tráfego da rede, para compartilhar informações com anunciantes de outros sites da rede, com o intuito de proporcionar comunicações promocionais relevantes que possam refletir seus interesses.',
    CLOSE: 'Fechar',
    MORE: 'Saiba mais',
    AGREE_YOUTUBE: 'Você deve aceitar cookies do Youtube para ver este vídeo',
    BUTTON_YOUTUBE: 'Aceitar cookies'
  },
  POPUP: { LAUNCH: 'POPUP-OUVERTURE-SITE' },
  FIELD_PLATE: { DISCOVER_VEGETABLE: 'Conheça nossos produtos' },
  SEARCH: {
    OUR_RECIPES: 'Receitas',
    OUR_PRODUCTS: 'Produtos',
    OUR_ARTICLES: 'Artigos',
    RECIPES: 'Receitas',
    PRODUCTS: 'Produtos',
    ARTICLES: 'Artigos',
    ALL: 'Tudo',
    SORT_BY: 'Ordenar por',
    RESULTS: 'Resultados',
    RESULT: 'Resultado',
    PRODUCT_OUT: 'Produtos de',
    APPLY: 'Aplicar',
    FILTER: 'Filtro',
    RECIPE_OUT: 'Receitas de',
    NO_RESULT: 'Ops... Você fez uma pergunta difícil',
    SEE_MORE: 'Veja mais',
    DISCOVER_RECIPES: 'Descubra as nossas receitas',
    SEE_MORE_OF: 'Ver mais sobre',
    DELETE: 'Deletar',
    SEE_ALL_PRODUCTS: 'Ver todos os nossos produtos'
  },
  RECIPE_LIST: {
    OUR_RECIPES: 'Receitas',
    RESULTS: 'Resultados',
    SEE_MORE: 'Ver mais receitas'
  },
  PRODUCT: {
    BUTTON: {
      ACTU: 'Novidades dos produtos',
      FOUND: 'Onde encontrar este produto',
      DISCOVER: 'Descubra toda a linha'
    },
    NUTRITIONAL_VALUE: 'Valores nutricionais',
    CONDITIONING: 'Embalagem',
    PORTIONS: 'Porções',
    NET_WEIGHT: 'Peso líquido',
    DRY_WEIGHT: 'Peso líquido escorrido',
    INGREDIENTS: 'Ingredientes',
    OUR_RECIPES: 'Descubra as nossas receitas',
    FOR: 'Para',
    PER_PORTION: 'e por porção de',
    ENERGY: 'Energia',
    FAT: 'Lípidos',
    SATURATE: 'Gorduras saturadas',
    GLUCIDES: 'Carboidratos',
    FIBER: 'Fibra',
    PROTEINS: 'Proteínas',
    SALT: 'Sal',
    DISCOVER_ALSO: 'Descubra também...',
    MORE_INFORMATION: 'Mais informação',
    TRACES: 'Traços de',
    CONTAINS: 'Contém',
    SLIDER: { SHEET: 'Ver informações', BUY: 'Onde comprar este produto?' },
    NUTRISCORE: 'informação-nutriscore',
    TRIMAN: 'informação-triman',
    AGRICONFIANCE: 'informação-agriconfiance',
    BIO: 'informação-bio',
    PESTICIDE_FREE: '',
    LEAF: '',
    LOCK: '',
    SEE_ALL: 'Ver todos os produtos',
    LEGISLATION: 'Conforme a legislação em vigor.',
    PORTION: { SINGULAR: 'Porção', PLURAL: 'Porções' },
    DISCLAIMER: '',
    COOKING: 'Preparação',
    CONSERVATION: 'Conservação'
  },
  FAQ: {
    ON: 'Perguntas sobre',
    ALL: 'Tudo',
    SEE_MORE: 'Ver mais perguntas',
    TITLE_1: 'Todas as respostas para suas perguntas',
    TITLE_2: 'Tem alguma pergunta sobre algum produto específico?',
    LINK_LABEL: 'Escreva para nós',
    BACK_TO_FAQ: 'Voltar às FAQ'
  },
  FORM: {
    GO_TO_STEP: 'Ir para o próximo passo',
    STEP: 'Passo',
    RECEIVE_EMAIL_COPY: 'Receber cópia por e-mail',
    SEND: 'Enviar',
    GDPR: 'Mais informações sobre o uso dos seus dados:\n' +
      'Na BONDUELLE BRASIL, somos responsáveis pelo tratamento dos dados pessoais que você nos fornece, os quais serão tratados com a finalidade de responder aos seus pedidos ou consultas realizadas e, se for o caso, proceder ao cadastro da sua conta no site.\n' +
      'A legitimidade para o tratamento é o consentimento prestado para enviar suas questões, proceder ao cadastro como usuário do Site e a aceitação das condições gerais de uso da conta. Você tem os seguintes direitos sobre seus dados: Acessar, retificar, excluir e se opor, limitar e transferir seus dados pessoais, perante a Bonduelle Brasil. Você poderá obter informações adicionais sobre proteção de dados na nossa Política de Privacidade.\n' +
      'Ao se cadastrar você consente expressamente o tratamento dos seus dados pessoais com as finalidades indicadas.',
    ERROR: 'Todos os campos com * são de preenchimento obrigatório.',
    SEND_ERROR: 'Ocorreu um erro, por favor, tente novamente mais tarde.',
    UPLOAD_ERROR: 'Sua solicitação não pôde ser enviada. Ocorreu um erro técnico ao carregar seu anexo. Tente novamente mais tarde. Se o problema persistir, entre em contato conosco para que possamos ajudá-lo.',
    THIRDPARTY_SERVICE_ERROR: 'Sua solicitação não pôde ser encaminhada. Ocorreu um erro técnico ao enviar sua mensagem para nossas equipes. Tente novamente mais tarde. Se o problema persistir, convidamos você a entrar em contato conosco novamente.',
    NOTICE: 'Para o correto tratamento do seu cadastro, a Bonduelle poderá, conforme o caso, solicitar dados sobre saúde. São facultativos, você é livre para não fornecê-los, se achar mais conveniente.',
    SENDING: 'Enviando formulário...',
    LOADING: 'Carregando...',
    PRODUCT_INFORMATION_TITLE: 'Informações sobre o produto',
    PRODUCT_INFORMATION: {
      SEO_TITLE: 'Informações e dados do produto Bonduelle',
      SEO_DESC: 'ntre em contato com nosso Serviço de Atendimento ao Consumidor para obter informações sobre os produtos das nossas linhas. Resposta personalizada em 48 horas.'
    },
    INFORMATIONS: 'Suas informações',
    MISTER: 'Estimado Sr.',
    MISS: 'Estimada Sr.ª',
    NAME: 'Nome',
    OUR_NAME: 'Seu nome',
    FIRSTNAME: 'Primeiro nome',
    OUR_FIRSTNAME: 'Seu primeiro nome',
    MAIL: 'Seu e-mail',
    MAIL_PLH: 'email@contato.com',
    MAIL_CONFIRM: 'Confirme o seu e-mail',
    MAIL_ERROR: 'Por favor, insira um endereço de e-mail válido',
    MAIL_ERROR_CONFIRM: 'Por favor, confirme seu endereço de e-mail',
    ADDRESS: 'Seu endereço',
    STREET_PLH: '',
    STREET: 'Número e nome da rua',
    ADDRESS_COMPLEMENT: 'Informações adicionais sobre o endereço',
    ADDRESS_COMP_PLH: 'Informação adicional',
    ZIPCODE: 'CEP',
    CITY: 'Cidade',
    CITY_PLH: 'Estado',
    PHONE: 'Telefone',
    PHONE_PLH: 'Seu número de telefone',
    COUNTRY: 'País',
    PRODUCT_INFORMATIONS: 'Informações sobre o produto',
    PRODUCT_INFORMATION_DESC: 'Para que nossos serviços possam analisar seu pedido da melhor forma possível, por favor forneça as seguintes informações:',
    PRODUCT: {
      DETAIL: {
        DESC: 'Para cada critério solicitado, você pode preencher o campo do formulário e anexar uma foto. Informação: sua foto deve mostrar claramente o código de barras, o número de lote e a data de validade (DLUO) do produto.'
      },
      NOTE: {
        TITLE: 'Fazer comentário sobre o produto',
        SEO_TITLE: 'Comentário sobre produto | Bonduelle',
        SEO_DESC: 'Deseja deixar uma observação ou comentário sobre algum produto da nossa linha? Entre em contato com nosso Serviço de Atendimento ao Consumidor para que possamos ajudá-lo(a). Resposta personalizada em 48 horas.'
      }
    },
    PRODUCT_RANGE: 'Linha de produtos afetada',
    PRODUCT_NAME: 'Nome do produto',
    PRODUCT_NAME_PLH: 'Digite o nome do produto Bonduelle a que se refere no seu pedido',
    PRODUCT_INFORMATIONS_DETAIL: 'Informação detalhada',
    PRODUCT_INFORMATIONS_LABEL: 'Código de barras do produto',
    PRODUCT_INFORMATIONS_PLH: 'O código de barras inscrito na embalagem do produto consiste em 13 dígitos.',
    PRODUCT_LOT: 'Número do lote do produto',
    PRODUCT_LOT_INFO: 'O número de lote começa com a letra L, seguido de vários dígitos, além de variar conforme o produto, como por exemplo: L72450492107:13.',
    PHOTO: 'Anexar foto',
    EXPIRED_DATE: 'Data da DLUO/DLC',
    EXPIRED_DATE_ERROR: 'Por favor, insira a data no formato dd/mm/aaaa',
    EXPIRED_DATE_DESC: 'A DLUO (data limite de utilização ótima) e a DLC (data limite de consumo) apresentam-se em forma de datas.',
    PHOTO_MORE: 'Fotos adicionais',
    MESSAGE: 'Sua mensagem *',
    OUR_MESSAGE: 'Escreva sua mensagem',
    SALES_OPERATIONS: {
      TITLE: 'Informações sobre uma ação comercial',
      SEO_TITLE: 'Informações sobre as ações atuais: jogos, concursos... | Bonduelle',
      SEO_DESC: 'Entre em contato com nosso Serviço de Atendimento ao Consumidor para obter informações sobre uma ação comercial em andamento. Resposta personalizada em 48 horas.'
    },
    PRESS_SERVICE: 'Entre em contato com nosso serviço de imprensa',
    FOOD_SERVICE: 'Entre em contato com nossa equipe de Bonduelle Food Service',
    BUSINESS_INFORMATION: '',
    MODAL_INFORMATION: '',
    JOB_OFFER: { TITLE: '', SEO_TITLE: '', SEO_DESC: '' },
    WEB_SUGGESTION: {
      TITLE: 'Fazer uma sugestão sobre o site',
      SEO_TITLE: 'Mensagem de melhoria, sugestão do site | Bonduelle',
      SEO_DESC: 'Entre em contato com nosso Serviço de Atendimento ao Consumidor para nos ajudar a melhorar o site.'
    },
    ANOTHER: {
      TITLE: 'Realizar outro pedido',
      SEO_TITLE: 'Contato para qualquer outro pedido, serviço | Bonduelle',
      SEO_DESC: 'Entre em contato com nosso Serviço de Atendimento ao Consumidor para obter informações, serviço ou sugestões. Resposta personalizada em 48 horas.'
    },
    AMBASSADOR: 'Torne-se um embaixador Bonduelle',
    CATEGORY: {
      SALAD: '',
      FROZEN: 'Congelado',
      CAN: 'Conserva',
      TAKEAWAY: '',
      VEGETABLE: ''
    },
    ACCESSIBILITY: {
      SEO_TITLE: 'Declaração de Acessibilidade',
      SEO_DESC: 'Declaração de Acessibilidade'
    }
  },
  CONTACT: {
    TITLE: 'À sua disposição',
    SPECIAL_INFO: '',
    TAKE_CARE: '',
    BY_MAIL: 'Por correio postal ou por e-mail',
    BY_PHONE: 'Por telefone',
    BY_SOURDLINE: '',
    MAIL_TEXT: 'Serviço de Atendimento ao Consumidor<br/>\n' +
      'Zona Industrial de Santarém<br/>\n' +
      '2005-002 Várzea Str<br/>\n' +
      '<br/>\n' +
      'E-mail : <a href="mailto:sac.brasil@bonduelle.com">sac.brasil@bonduelle.com</a>',
    PHONE_TEXT: 'Nosso serviço de Atendimento ao Consumidor está à sua disposição de segunda a sexta-feira, das 09h00 às 18h00. No entanto, você pode deixar uma mensagem de voz, 24 horas por dia no número +351 243 359 070 (chamada para a rede fixa nacional)',
    SOURDLINE_TEXT: '',
    BY_DISTRIBUTOR: '',
    BY_DISTRIBUTOR_TEXT: '',
    SUBTITLE: 'Deseja entrar em contato conosco para:',
    AGREEMENT: '',
    READ_MORE: 'Além disso, você tem o direito de acesso, retificação, exclusão e portabilidade dos seus Dados Pessoais, bem como o direito de limitação e oposição ao tratamento dos Dados Pessoais que lhe digam respeito, que você pode exercer escrevendo para Dpo_brasil(at)bonduelle(ponto)com ou por e-mail: aos cuidados do Encarregado de Proteção de Dados, Bonduelle Brasil, [endereço brasileiro]. Para saber mais sobre o uso dos seus dados e dos seus direitos clique aqui',
    READ_MORE_LABEL: 'Saiba mais',
    SATISFACTION_TEXT: 'Para entrar em contato com você e fornecer as informações solicitadas sobre o produto e para enviar um questionário de satisfação se você desejar, processaremos as informações fornecidas na nossa qualidade de responsável pelo tratamento dos dados. A base legal para processar seu pedido é o consentimento devido aos potenciais dados relacionados com a saúde que você pode fornecer no seu pedido. Essas informações serão conservadas durante o tempo necessário para processar seu pedido e até 5 anos para comprovar que seu pedido foi processado e para cumprir nossas obrigações legais. A base legal para o envio do questionário de satisfação é também o seu consentimento. Essas informações serão conservadas durante o tempo necessário para o envio do questionário de satisfação e até no máximo 1 ano. Para saber mais sobre o tratamento dos seus dados pessoais, consulte nossa <a href="https://www.bonduelle.com.br/politica-de-privacidade" target="_blank" class="underline">Política de Privacidade</a>.',
    SATISFACTION_CHECKBOX: 'Ao marcar esta caixa, você concorda em receber um questionário de\n' +
      'satisfação (composto por uma única pergunta) assim que sua solicitação\n' +
      'for processada. Isso é opcional.',
    CHECKBOX_TEXT: 'Ao marcar esta caixa, você concorda que a Bonduelle possa processar os dados pessoais de saúde que você fornecer em sua mensagem com o único propósito de responder à sua solicitação. <strong>Isso é obrigatório para processar sua solicitação</strong>.',
    PHONE: 'De segunda a sexta-feira, das 08h00 às 18h00, exceto feriados nacionais, pelo telefone número +351 243 359 070 (chamada para a rede fixa nacional)',
    CALL_US: 'Entre em contato',
    TO_WRITE: 'Escreva para a gente',
    PHONE_NUMBER: '00351 243 359 070',
    SUCCESS_MESSAGE: 'Obrigado! Sua mensagem foi recebida pela nossa equipe. Será processada em um período estimado de 2 a 3 dias, excluindo finais de semana e feriados.\n' +
      'Permanecemos ao seu serviço, de segunda a sexta-feira, das 09h00 às 18h00, pelo telefone número +351 243 359 070 (chamada para a rede fixa nacional).\n' +
      'Como parte da supervisão da nossa qualidade de serviço, as chamadas poderão ser gravadas.',
    PHOTOERROR: { MESSAGE: '' }
  },
  GLOBAL: { READ_MORE: 'Leia mais' },
  FLOWBOX: { GENERIC_KEY: '', PRODUCT_KEY: '', RECIPE_KEY: '', HOME_KEY: '' },
  TOKEN: {
    FACEBOOK: '',
    PAGE_FACEBOOK_ID: '',
    INSTAGRAM: '',
    INSTA_ID: 17841408019332200,
    YOUTUBE: '',
    TWITTER: '',
    MAGAZINE: ''
  },
  COOKIE: {
    BANNER: {
      MANDATORY: 'Obrigatório',
      ANALYTICS: 'Análise',
      MARKETING: 'Marketing',
      SOCIAL_MEDIA: 'Redes sociais',
      ACCEPT: 'Aceitar tudo',
      REJECT: 'Rejeitar tudo',
      SET_UP: 'Configuração',
      MANDATORY_DETAILS: 'Os cookies necessários são necessários para o funcionamento do site, por exemplo, para armazenar suas informações de login e fornecer uma conexão segura.\n' +
        'Os cookies necessários para usar o site bonduelle.com.br são:\n' +
        '<ul>\n' +
        '<li> cookies de sessão: cookies gerados por aplicativos baseados em PHP. Este é um identificador de propósito geral usado para gerenciar variáveis de sessão do usuário. Normalmente é um número gerado aleatoriamente, a forma como é usado pode ser específica do site, mas um bom exemplo é manter um estado de login para um usuário entre as páginas. </li>\n' +
        '</ul>',
      ANALYTICS_DETAILS: 'Os cookies funcionais nos ajudam a otimizar o site, por exemplo, para coletar estatísticas, registrar suas preferências para interações sociais ou medir o desempenho e a estabilidade de nosso aplicativo.\n' +
        'Os cookies analíticos usados pelo site bonduelle.com.br são:\n' +
        '<ul>\n' +
        '<li> DoubleClick: este cookie é definido por um DoubleClick (propriedade do Google) para criar um perfil com os interesses do visitante do site e mostrar anúncios relevantes em outros sites. A principal atividade da empresa é a troca de anúncios pelas ofertas do Google em tempo real. </li>\n' +
        '<li> Google Analytics: esses cookies permitem que você rastreie as páginas mais visitadas e o tráfego do site. </li>\n' +
        '<li> UTMTracking: este cookie permite a gestão de variáveis UTM para um acompanhamento ideal das diferentes campanhas de publicidade online </li>\n' +
        '</ul>',
      MARKETING_DETAILS: 'Os cookies de marketing nos permitem rastrear suas receitas e preferências de produto para que possamos sempre oferecer os produtos que melhor se adaptam à sua pesquisa.\n' +
        'Os cookies de marketing usados pelo site bonduelle.com.br são:\n' +
        '<ul>\n' +
        "<li> Redes sociais: esses cookies permitem que o 'SocialWall' da Bonduelle seja exibido na página inicial do site. Este mural permite que você veja as publicações mais recentes das principais redes sociais utilizadas pelo Grupo Bonduelle. </li>\n" +
        '</ul>',
      V2: 'ok'
    },
    MODAL: {
      TITLE: 'Gerenciar cookies',
      TEXT: 'O Grupo Bonduelle se compromete a garantir a proteção dos dados pessoais dos usuários de seus sites e, em particular, do site Bonduelle.com.br. Para permitir que você usufrua dos serviços que o site oferece, como a consultoria de produtos, a descoberta de novas receitas gourmet, a assinatura de determinados serviços como nossas Newsletters e também a otimização do seu uso e personalização de acordo com o seu perfil, nosso site utiliza cookies. O Grupo Bonduelle está totalmente empenhado em garantir um alto nível de proteção com relação a esses Dados Pessoais e em cumprir todas as regulamentações de proteção de dados aplicáveis ao processar Dados Pessoais em conexão com o uso do nosso website. Portanto, você pode habilitar/desabilitar os cookies a qualquer momento.',
      CONFIG: 'Configuração',
      SAVE: 'Salve'
    }
  },
  LINK: { JOB_OFFERS: 'https://jobs.bonduelle.com/?locale=pt_PT' },
  CLIC2BUY: { INFOS: '' },
  HOMEPAGE: {
    SLOGAN: 'O bom sempre ganha',
    DISCOVER: 'Descubra as nossas receitas inspiradoras e deliciosas à base de legumes',
    FIND_RECIPE: 'Encontrar uma receita',
    NEW_RECIPES: 'Ver as novas receitas',
    FEAT_RECIPES: 'Receitas em destaque',
    ALL_RECIPES: 'Ver todas as nossas receitas',
    VEGGIES_FOR: 'Nossos vegetais para…',
    RANGE_DISCOVER: 'Descubra as nossas gamas',
    COMMITMENT: 'O nosso compromisso consigo',
    CARE_AND_PASSION: 'Legumes cultivados com cuidado e paixão',
    TECHNOLOGIES: 'Tecnologias desenvolvidas para garantir a qualidade e a segurança de produtos saborosos e fiáveis',
    BIODIVERSITY: 'Uma abordagem que respeita a biodiversidade, o solo e o ritmo das estações, graças a agricultores comprometidos.',
    DISCOVER_COMMINTMENTS: 'Descubra os nossos compromissos',
    FIND_PRODUCT: 'Encontrar um produto'
  },
  ABOUT: { NEWS: 'Descubra todas as nossas novidades' },
  STATS: {
    GENERATIONS: '7 gerações da família Bonduelle desde 1853',
    PRODUCERS: 'Inspirar a transição para uma alimentação vegetal e rica em vegetais',
    BCORP: 'Somos certificados BCorp em nível mundial',
    TRANSITION: 'Inspirar a transição para uma dieta rica em vegetais.',
    TRANSITION_TITLE: 'Transição '
  },
  COMITMENT: { TITLE: { UP: 'Nosso compromisso', DOWN: 'para você' } },
  BREADCRUMB: { HOME: 'Início' },
  FOOTNOTES: { ABOUT_US: '' },
  AI: {
    DESIGNED_PRODUCED: 'Imagem concebida pela nossa equipa e produzida com a ajuda da IA',
    DESIGNED_RETOUCHED: 'Imagem concebida pela nossa equipa e retocada com a ajuda da IA',
    GENERATED: 'Imagem gerada por IA',
    RETOUCHED: 'Imagem retocada por IA',
    BACKGROUND_GENERATED: 'Imagem de fundo gerada por IA',
    BACKGROUND_RETOUCHED: 'Imagem de fundo retocada por IA',
    PRODUCT_GENERATED: 'Imagem de produto gerada por IA',
    PRODUCT_RETOUCHED: 'Imagem de produto retocada por IA',
    VIDEO_DESIGNED_PRODUCED: 'Vídeo concebido pela nossa equipa e produzido com a ajuda da IA',
    VIDEO_DESIGNED_RETOUCHED: 'Vídeo concebido pela nossa equipa e retocado com a ajuda da IA',
    VIDEO_GENERATED: 'Vídeo gerado por IA',
    VIDEO_RETOUCHED: 'Vídeo retocado por IA'
  }
};
